import { all, AllEffect } from '@redux-saga/core/effects';
import { call, Effect } from 'redux-saga/effects';

import watchGetPasswordStatusSaga from './getPasswordStatusSaga';
import watchPutPasswordSaga from './putPasswordSaga';

export default function* passwordSaga(): Generator<AllEffect<Effect>, void, unknown> {
  yield all([call(watchGetPasswordStatusSaga), call(watchPutPasswordSaga)]);
}
